import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeTask(task: Boundaries["removeTask"]["request"]): void;
}

function useTaskRemoval(task: Identifiable<Task>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveTaskRequestPending(task),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveTaskRequestSuccess(task),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveTaskRequestFailure(task),
    ),
    removeTask: core.removeTask,
  };
}

export { useTaskRemoval };
